import React from "react";
import css from "./LoadingIndicator.module.css";
import { useResourcesState } from "@/state/resourcesState";
import { Column } from "@/dom/components/Panel/Column";

export const LoadingIndicator = () => {
    const { loadingMessage } = useResourcesState();
    return (
        <div className={css.main}>
            <Column align="center">
                <svg
                    width="48"
                    height="48"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className={css.sparks}
                >
                    <path
                        d="M12.922 22.364C13.946 17.524 15.926 15.34 19.844 14.182C15.926 13.024 13.946 10.84 12.924 6C11.944 10.63 10.094 12.97 6 14.18C9.918 15.34 11.898 17.524 12.922 22.364Z"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M29.5402 12.546C31.6802 21.392 34.1322 24.616 42.0002 27.272C33.2002 29.0896 30.0255 37.848 29.5382 42C27.4022 33.172 24.9362 29.926 17.0762 27.272C24.5642 24.742 27.2922 21.844 29.5402 12.546Z"
                        stroke="black"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                <div>{loadingMessage}</div>
            </Column>
        </div>
    );
};
